export type BannerStatus = 'paused' | 'withdrawn' | 'completed' | 'screen_failed';

export const STATUS_BANNER_CONFIG: Record<BannerStatus, {icon: string; title: string}> = {
  completed: {icon: '✓', title: 'gritx.programDetail.status.completed'},
  paused: {icon: '⏸', title: 'gritx.programDetail.status.paused'},
  withdrawn: {icon: '✕', title: 'gritx.programDetail.status.withdrawn'},
  screen_failed: {icon: '–', title: 'gritx.programDetail.status.screenFailed'}
};

export const STATUS_BANNER_DEFAULTS: Record<BannerStatus, string> = {
  completed: 'You\'ve finished this program — thank you',
  paused: 'This program has been paused',
  withdrawn: 'You have been withdrawn from this program',
  screen_failed: 'This program is no longer active'
};
